<div class="auth">
  <header class="auth-header">
    <img src="assets/images/logo.png" alt="SipSignal Efax Logo" class="auth-header-logo" />
  </header>

  <main class="auth-main">
    <h1 class="h2">Password recovery</h1>

    <form [formGroup]="form" class="auth-form" (ngSubmit)="requestPasswordReset()">
      <input formControlName="email" type="email" placeholder="E-mail" class="form-input_lg" />

      <div class="auth-form-actions">
        <button type="submit" [disabled]="form.invalid" class="btn_primary btn_lg auth-form-submit-button">
          Restore password
        </button>

        <a routerLink="/auth" class="link auth-form-login-link">Login</a>
      </div>

      <p *ngIf="isRequestError" class="form-error">{{ requestErrorMessage }}</p>
    </form>
  </main>
</div>

<app-success-modal
  text="A password reset link has been sent to your email. Check your inbox to reset your password."
  buttonText="Return to the homepage"
  (close)="navigateToAuth()"
></app-success-modal>
